import { pushRoute } from '../../../lib/router.js';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import {
  DragDropContext,
  Draggable,
  Droppable,
  resetServerContext,
} from 'react-beautiful-dnd';
import { INITIATIVE_TYPES } from '../../../lib/schema.js';
import FieldGroup from '../../FieldGroup.jsx';
import { isAuthorized } from '../../AuthorizedAction.js';
import { FormError } from '../../FormError.jsx';

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'none' : 'none',
});

const OrgInitiativeCategoriesSettingForm = (props) => {
  const {
    submitError,
    submitFailed,
    submitting,
    permissions,
    handleSubmit,
    onDragEnd,
    onCreateColumn,
    onDeleteColumn,
    onColumnNameChange,
    data,
  } = props;

  resetServerContext();

  const onCancel = () => {
    pushRoute('organization/custom-settings');
  };

  return (
    <form onSubmit={handleSubmit}>
      {INITIATIVE_TYPES.map((category) =>
        isAuthorized('update', `${category}Initiative`, permissions) ? (
          <Row key={`${category}Initiative`} className="m-b-60">
            <Col xs={12}>
              <h2 className="column-header m-b-24 text-capitalize">
                {category}
              </h2>
              <DragDropContext
                onDragEnd={(result) => onDragEnd(result, category)}
              >
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      {data[category].map((item, index) => (
                        <Draggable
                          key={item.draggableId}
                          draggableId={item.draggableId}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                            >
                              <Row>
                                <Col xs={1}>
                                  <span
                                    className="btn-move btn btn-default"
                                    {...provided.dragHandleProps}
                                  ></span>
                                </Col>
                                <Col xs={4}>
                                  <Field
                                    id={item.draggableId}
                                    name={item.draggableId}
                                    className="m-0"
                                    placeholder="Enter Title"
                                    disabled={
                                      item.nativeColumn === 'influence' ||
                                      item.nativeColumn === 'interest'
                                    }
                                    type="text"
                                    label=""
                                  >
                                    {(props) => (
                                      <FieldGroup
                                        {...props}
                                        value={item.name}
                                        onChange={(event) =>
                                          onColumnNameChange(
                                            event.target.value,
                                            index,
                                            category
                                          )
                                        }
                                      />
                                    )}
                                  </Field>
                                </Col>
                                <Col xs={1}>
                                  <button
                                    type="button"
                                    disabled={!item.allowDelete}
                                    className="btn-delete btn btn-default"
                                    onClick={() =>
                                      onDeleteColumn(category, item.draggableId)
                                    }
                                  ></button>
                                </Col>
                              </Row>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Col>
            <Col xs={12}>
              <button
                disabled={data[data.length - 1] && !data[data.length - 1].name}
                className="btn-link"
                onClick={(event) => {
                  event.preventDefault();
                  onCreateColumn(category);
                }}
              >
                {' '}
                + Create New Category
              </button>
            </Col>
          </Row>
        ) : null
      )}

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <Button bsStyle="default" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default OrgInitiativeCategoriesSettingForm;
